import {Component, OnInit} from '@angular/core';
import {BannerLayoutComponent} from '../../banner-layout.component';
import {BannerContentModel} from '../banner-content.model';
import {TranslationService} from '../../../../services/wrapper/translation.service';
import {BsModalService} from 'ngx-bootstrap';
import {NotificationService} from '../../../../services/common/notification.service';
import {MyStorageService} from '../../../../services/common/my-storage.service';

@Component({
    selector: 'app-title-desc-two-link-content',
    templateUrl: './title-desc-two-link-content.component.html',
    styleUrls: ['./title-desc-two-link-content.component.scss']
})
export class TitleDescTwoLinkContentComponent extends BannerLayoutComponent<BannerContentModel> implements OnInit {
    title = '';
    linkText = '';
    linkTwoText = '';
    link = '';
    linkTwo = '';
    description = '';

    constructor(translationService: TranslationService, modalService: BsModalService, notificationService: NotificationService, myStorageService: MyStorageService) {
        super(translationService, modalService, notificationService, myStorageService);
    }

    ngOnInit(): void {
        this.title = this.translate(this.data.title);
        this.linkText = this.translate(this.data.linkText);
        this.link = this.translate(this.data.link);
        this.linkTwoText = this.translate(this.data.linkTwoText);
        this.linkTwo = this.translate(this.data.linkTwo);
        this.description = this.translate(this.data.description);
    }

    navigate(link: string) {
        alert(link);
    }
}
